import { PermissionType } from '../constants/enums/permission-type-enum';
import userTypeEnum from '../constants/enums/user-type-enum';
import authStore from '../core/stores/auth-store';
import { IActionFormatter } from '../models/ICommon';
import { IRoleVM } from '../models/response/IRoleResponse';

export const showIconsRoleBase = (
  AddIcons: IActionFormatter[],
  module: number
): IActionFormatter[] => {
  let userPermission: any = authStore.getAllPermission;
  let userRole: any = authStore.getUserType;
  let icons: IActionFormatter[] = AddIcons;
  if (userRole === userTypeEnum[0] || userRole === userTypeEnum[1]) {
    return icons;
  } else {
    if (JSON.stringify(userPermission) === '[]') {
      const permissions = localStorage.getItem('oms_permissions');
      if (permissions) userPermission = JSON.parse(permissions);
    }
    let modulePermission = userPermission.filter(
      (per: IRoleVM) => per.ModuleType == module
    );
    if (modulePermission?.length === 1) {
      if (modulePermission[0]?.PermissionType == PermissionType.ViewOnly)
        icons = icons.filter(
          (icon: IActionFormatter) =>
            icon.action !== 'edit' && icon.action !== 'delete'
        );
    } else if (modulePermission[0]?.PermissionType == PermissionType.Hide) {
      icons = icons.filter(
        (icon: IActionFormatter) =>
          icon.action !== 'edit' &&
          icon.action !== 'delete' &&
          icon.action !== 'view'
      );
    }
  }
  return icons;
};

export const isOperationPermittedRoleBase = (module: number, action: any) => {
  let predefinedActions = ['Add', 'Edit', 'Delete', 'Copy'];
  let userPermission: any = authStore.getAllPermission;
  let userRole: any = authStore.getUserType;
  if (userRole === userTypeEnum[0] || userRole === userTypeEnum[1]) {
    return true;
  } else {
    if (JSON.stringify(userPermission) === '[]') {
      const permissions = localStorage.getItem('oms_permissions');
      if (permissions) userPermission = JSON.parse(permissions);
    }
    let allAccess = predefinedActions.filter((data: string) => {
      return data == action;
    });
    let modulePermission = userPermission.filter((per: IRoleVM) => {
      return per.ModuleType == module;
    });

    if (modulePermission.length === 1 && allAccess.length > 0) {
      return modulePermission[0].PermissionType == PermissionType.AllAccess;
    }
    return false;
  }
};
